module.exports = new __parcel__URL__("report-epic-or-release-burndown.678f9aa2.svg").toString();